import { Routes } from '@angular/router';
import { HomePageComponent } from './components/home-page/home-page.component';
import { SuccessPageComponent } from './components/success-page/success-page.component';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { CancelPageComponent } from './components/cancel-page/cancel-page.component';

export const routes: Routes = [
    { path: 'web', component: HomePageComponent},
    { path: 'success', component: SuccessPageComponent},
    { path: 'error', component: ErrorPageComponent},
    { path: 'cancel', component: CancelPageComponent},
    { path: '**', redirectTo: '/web', pathMatch: 'full' },
];
